import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { result } from 'lodash';
import { AlertsCenterService } from 'src/app/core/services/alerts-center.service';
import { TipoDocumento } from 'src/app/model/TipoDocumento.enum';
import { InvioSegnalazioniService } from 'src/app/services/invio-segnalalazioni.service';

@Component({
  selector: 'app-invia-segnalazioni',
  templateUrl: './invia-segnalazioni.component.html',
  styleUrls: ['./invia-segnalazioni.component.css']
})
export class InviaSegnalazioniComponent implements OnInit {

  confermaInvioSegnalazioni: boolean = false;
  idInvio: Number;
  nomeFilePdf: string;
  nomeFileExcel: string;
  documentoLettoPdf: boolean = false;
  documentoLettoExcel: boolean = false;
  confermaDocumentoLetto: boolean = false;
  idEvento: number;
  idInvioGenerato: boolean = false;

  constructor(private alertsCenterService: AlertsCenterService, private invioSegnalazioniSvc: InvioSegnalazioniService, private dialogRef: MatDialogRef<InviaSegnalazioniComponent>, @Inject(MAT_DIALOG_DATA) data) {
    this.idEvento = data.idEvento;
  }

  ngOnInit(): void {

  }

  documentiLetti(): boolean {
    return this.documentoLettoPdf && this.documentoLettoExcel;
  }

  confermaInvio(event: Event) {
    if (event['checked'] == true) {
      //chiamata al servizio BE
      this.confermaInvioSegnalazioni = true;
      this.invioSegnalazioniSvc.postIdInvio().subscribe(
        idInvio => {
          this.idInvio = idInvio;
          this.nomeFilePdf = `segnalazioni-${this.idInvio}.pdf`;
          this.nomeFileExcel = `segnalazioni-${this.idInvio}.xls`;
          this.idInvioGenerato = true;
        }, err => {
          this.alertsCenterService.showAlert({
            message: 'Errore in fase di generazione del codice documento...',
            type: 'danger',
            autoClosable: false,
          });
          this.idInvioGenerato = false;
          this.dialogRef.close();
        }
      )
    }
  }

  downloadSegnalazioniDaInviarePdf() {
    this.documentoLettoPdf = false;
    this.invioSegnalazioniSvc.downloadSegnalazioniDaInviare(this.idInvio, this.idEvento, TipoDocumento.PDF).subscribe(
      response => {
        this.documentoLettoPdf = true;
        let dataType = response.type.toString();
        let binaryData = [];
        binaryData.push(response.body);
        let contentDisposition = response.headers.get('content-disposition')
        let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
        filename = filename.replace(/"/g, '');
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }, err => {
        this.alertsCenterService.showAlert({
          message: 'Errore in fase di download del file pdf...',
          type: 'danger',
          autoClosable: false,
        });
        this.dialogRef.close();
      })
  }

  downloadSegnalazioniDaInviareExcel() {
    this.documentoLettoExcel = false;
    this.invioSegnalazioniSvc.downloadSegnalazioniDaInviare(this.idInvio, this.idEvento, TipoDocumento.EXCEL).subscribe(
      response => {
        this.documentoLettoExcel = true;
        let dataType = response.type.toString();
        let binaryData = [];
        binaryData.push(response.body);
        let contentDisposition = response.headers.get('content-disposition')
        let filename = contentDisposition.split(';')[1].split('filename')[1].split('=')[1].trim();
        filename = filename.replace(/"/g, '');
        let downloadLink = document.createElement('a');
        downloadLink.href = window.URL.createObjectURL(new Blob(binaryData, {type: dataType}));
        downloadLink.setAttribute('download', filename);
        document.body.appendChild(downloadLink);
        downloadLink.click();
      }, err => {
        this.alertsCenterService.showAlert({
          message: 'Errore in fase di download del file excel...',
          type: 'danger',
          autoClosable: false,
        });
        this.dialogRef.close();
      })
  }

  confermaLettura(event: Event) {
    if (event['checked'] == true) {
      this.confermaDocumentoLetto = true;
    } else {
      this.confermaDocumentoLetto = false;
    }
  }

  inviaSegnalazioni() {
    this.invioSegnalazioniSvc.inviaSegnalazioni(this.idInvio, this.idEvento).subscribe(
      result => {
        if (result >= 1) {
          this.alertsCenterService.showAlert({
            message: `Segnalazioni inviate correttamente, numero: ` + result,
            type: 'success',
            autoClosable: false
          });
        } else {
          this.alertsCenterService.showAlert({
            message: `Segnalazioni inviate ` + result,
            type: 'danger',
            autoClosable: false
          });
        }
        this.dialogRef.close();
      }, err => {
        this.alertsCenterService.showAlert({
          message: err.error.esitoServizio.descrizioneEsito,
          type: 'danger',
          autoClosable: false,
        });
        this.dialogRef.close();
      })
  }
}
